module.exports = __webpack_public_path__ + "static/media/treeconomics.b26531af.png";